/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_Plh_Col_QtyInputs */

const vi_pkl_plh_col_qty = /** @type {(inputs: Pkl_Plh_Col_QtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SL lấy`)
};

/**

* @param {Pkl_Plh_Col_QtyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_plh_col_qty = /** @type {((inputs?: Pkl_Plh_Col_QtyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_Plh_Col_QtyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_plh_col_qty(inputs)
});